import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import mutation from './mutation.graphql'
import SignUpForm from './form'
import { notify } from '../Notifications'
import UserContext from '../../lib/user-context'

export default class SignUp extends Component {
  state = {
    email: '',
    password: '',
    passwordConfirmation: '',
    errors: {}
  };

  static contextType = UserContext

  handleSubmit = mutation => async e => {
    const { email, password, passwordConfirmation } = this.state
    e.preventDefault()
    const { data: { signUp: { token, errors, result: { success, reason } } } } = await mutation({ variables: {
      email,
      password,
      passwordConfirmation
    } })
    if (!success) {
      this.setState({ errors })
      return notify(reason.message, 'danger')
    }
    this.context.signIn({ token })
  };

  onChange = field => value => {
    this.setState({ errors: {}, [field]: value })
  };

  handleKeyPress = mutation => event => {
    if (event.key === 'Enter') {
      this.handleSubmit(mutation)(event)
    }
  };

  render () {
    return (
      <Mutation mutation={mutation}>
        {mutation => <SignUpForm onSubmit={this.handleSubmit(mutation)} onKeyPress={this.handleKeyPress(mutation)} onChange={this.onChange} {...this.state} />}
      </Mutation>
    )
  }
}
